<template>
  <div v-if="procedure">
    <div class="columns is-gapless is-border-bottom is-marginless has-background-white">
      <div
        @click="toggleProcedure()"
        class="column is-narrow has-background-white is-border-right is-border-left is-flex is-padding-small">
        <span class="icon is-self-centered"><i
          class="fal"
          :class="open ? 'fa-chevron-down': 'fa-chevron-right'"></i></span>
      </div>
      <div
        @click="toggleProcedure()"
        class="column is-self-centered is-padding-left is-padding-right">
        <div
          v-if="procedure.status === 'draft' || procedure.status === 'ongoing' || procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'rejected'"
          class="is-size-6 is-uppercase">
          Procédure lancée le {{ procedure.created_on | date }} à {{ procedure.created_on | dtFormat('HH[H]mm') }}
        </div>
        <div
          v-if="procedure.status === 'done'"
          class="is-size-6 is-uppercase">
          Procédure terminée le {{ procedure.updated_on | date }} à {{ procedure.updated_on | dtFormat('HH[H]mm') }}
        </div>
      </div>
      <div
        v-if="procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'rejected'"
        class="column is-narrow is-flex is-padding-small">
        <span class="has-text-danger is-self-centered is-uppercase is-size-7">
          <span v-if="procedure.status === 'deleted'">Annulée le {{ procedure.deleted_on | date }} à {{ procedure.deleted_on | dtFormat('HH[H]mm') }}</span>
          <span v-else-if="procedure.status === 'expired'">Expirée le {{ procedure.updated_on | date }} à {{ procedure.updated_on | dtFormat('HH[H]mm') }}</span>
          <span v-else-if="procedure.status === 'rejected'">Refusée le {{ procedure.updated_on | date }} à {{ procedure.updated_on | dtFormat('HH[H]mm') }}</span>
        </span>
      </div>
      <a
        v-else
        @click="confirmCancel()"
        class="column is-narrow has-background-white--darken1 is-flex is-padding-small">
        <span class="has-text-dark is-self-centered is-uppercase is-size-7">Annuler procédure</span>
      </a>
    </div>
    <div v-if="open">
      <div
        v-if="(!canSign && member_last_send_mail === false) && (procedure.status === 'draft' || procedure.status === 'ongoing')"
        class="notification has-text-centered is-marginless is-success">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-check-square"></i></span>
          <span class="has-text-weight-medium">Procédure activée : </span>Pour une signature à distance, pensez à inviter les signataires par email
        </p>
      </div>
      <div
        v-else-if="procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'rejected'"
        class="notification is-warning has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
          <span
            v-if="procedure.status === 'rejected'"
            class="has-text-weight-medium">Procédure refusée</span>
          <span
            v-else
            class="has-text-weight-medium">Procédure annulée :</span>
          <span v-if="'deleted_by' in procedure && procedure.deleted_by.last_name && procedure.deleted_by.first_name">
            <span><span class="is-uppercase">{{ procedure.deleted_by.last_name }}</span> {{ procedure.deleted_by.first_name }}</span>
          </span>
          <span v-else>
            <span v-if="procedure.status === 'expired'">delais expiré</span>
          </span>
        </p>
      </div>
      <div v-if="procedure.deleted_reason">
        <div>
          <div class="vadDiscussion is-border-top">
            <div class="vadDiscussion--bulle is-size-6 vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div class="is-margin-bottom-xxsmall">
                <span class="is-size-7">
                  <b>Date : </b>{{ procedure.deleted_on |date }} -<b data-v-648c4338="">Auteur : </b>
                  <span v-if="'deleted_by' in procedure && procedure.deleted_by.last_name && procedure.deleted_by.first_name"><span class="is-uppercase">{{ procedure.deleted_by.last_name }}</span> {{ procedure.deleted_by.first_name }}</span>
                </span>
              </div>
              <div
                data-v-648c4338=""
                class="content">
                <p v-html="procedure.deleted_reason"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-background-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
        <span class="is-uppercase title is-6">Signature réservataire / acquéreur</span>
      </div>
      <!----------------- CONTRAT ACQUEREUR --------------->
      <template v-for="(membre, idx) in membresBuyer">
        <div
          :key="idx"
          class="is-margin-bottom-xsmall is-border">
          <contrat-item
            :procedure-lre="procedureLre"
            :membre="membre"
            :idx="idx"
            :procedure="procedure"
            :signatures="signatures"
            @addLre="addLre"></contrat-item>
        </div>
      </template>
      <!----------------- CONTRAT PROMOTEUR --------------->
      <div class="is-border is-margin-bottom-xsmall">
        <div class="columns is-gapless has-background-white is-marginless">
          <div
            class="column is-narrow is-flex is-padding-small tooltip is-tooltip-right"
            :data-tooltip="membrePromoteur.status === 'notified' ? 'En attente de contre signature' : 'Refusé'"
            :class="membrePromoteur.status === 'notified' || membrePromoteur.status === 'declined' ? 'has-background-white--darken1 is-border-right' : 'has-background-success'">
            <span
              class="icon is-self-centered"
              :class="membrePromoteur.status === 'notified' || membrePromoteur.status === 'declined' ? 'has-text-danger' : 'has-text-white'">
              <i
                v-if="membrePromoteur.status === 'notified'"
                class="fas fa-clock"></i>
              <i
                v-else-if="membrePromoteur.status === 'declined'"
                class="fas fa-exclamation-circle"></i>
              <i
                v-else
                class="fas fa-check-circle"></i>
            </span>
          </div>
          <div class="column columns is-gapless is-padding-small is-multiline">
            <div class="column is-6 is-4-widescreen is-3-fullhd is-padding-xxsmall">
              <r-label
                :label="'Réservant / Promoteur'"
                :is-required="false"></r-label>
              <div class="title is-5">
                <span class="is-uppercase">{{ membrePromoteur.last_name }} </span>
                <span style="text-transform: capitalize">{{ membrePromoteur.first_name }}</span>
              </div>
              <div
                v-if="membrePromoteur.status === 'done' || membrePromoteur.status === 'signed'"
                class="is-padding-bottom-xsmall">
                <span
                  class="is-size-7 has-text-success is-uppercase">Signé le {{ membrePromoteur.updated_on | date }} à {{ membrePromoteur.updated_on | dtFormat('HH[H]mm') }}</span>
                <div
                  class="has-text-weight-semibold is-italic is-size-7">
                  ID signature: {{ membrePromoteur.file_id }}
                </div>
              </div>
            </div>
            <div class="column is-12 is-4-widescreen is-6-fullhd columns is-gapless is-multiline">
              <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
                <r-label
                  :label="'Téléphone'"
                  :is-required="false"></r-label>
                <div class="title is-5 has-text-weight-normal">
                  <phone-number
                    phone-class="is-margin-right-small"
                    :phone="membrePromoteur.phone"></phone-number>
                </div>
              </div>
              <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
                <r-label
                  :label="'Mail'"
                  :is-required="false"></r-label>
                <div class="title is-5 has-text-weight-normal">
                  <span>{{ membrePromoteur.email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="membrePromoteur.comment"
          class="columns is-gapless has-background-warning is-border-top is-padding-small">
          <div class="column is-12 is-padding-left-large">
            <div class="is-uppercase is-size-6">
              <b>PROCÉDURE ANNULÉE : Commentaires</b>
            </div>
            <div class="is-padding-top-small is-size-6">
              {{ membrePromoteur.comment }}
            </div>
            <div class="is-uppercase is-padding-top-small is-size-6">
              <span><b>Date :</b></span>
              {{ membrePromoteur.updated_on | dateRefus }}
            </div>
          </div>
        </div>
        <div
          v-if="!canSign && procedure.status !== 'deleted'"
          class="notification is-warning has-text-centered is-marginless">
          <p class="is-uppercase is-size-7">
            <span class="has-text-weight-medium">SIGNATURE DISPONIBLE LORSQUE LE OU LES ACQUÉREURS AURONT SIGNÉ</span>
          </p>
        </div>
        <div
          v-else-if="isAdmin && isPromoteur && membrePromoteur.status !== 'declined' && procedure.status !== 'deleted'"
          class="is-padding-bottom-small columns is-border-top is-gapless is-centered has-background-white is-padding-top-small ">
          <div class="is-margin-left-small">
            <a
              v-if="membrePromoteur.status === 'signed'"
              @click="openPreview(membrePromoteur)"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </a>
            <a
              v-else-if="procedure.status === 'done'"
              @click="openPreviewContrat()"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </a>
            <!-- <div v-else-if="">

            </div> -->
            <div
              v-else
              style="display: flex !important; align-items: center; gap: 10px; flex-wrap: wrap;">
              <a
                @click="openPreview(membrePromoteur)"
                class="button is-small is-success is-size-6 is-transform-none is-radius same-width">
                <div class="veryFastAnimation">
                  <span>Signer contrat</span>
                </div>
              </a>
              <button
                @click="sendYousignContractByMail(membrePromoteur)"
                class="button is-small is-success is-size-6 is-transform-none is-radius same-width">
                <span class="is-uppercase">Envoyer contrat par email</span>
              </button>
              <div
                v-if="membrePromoteur.last_send_mail"
                class="has-text-weight-semibold is-italic is-size-7">
                <span>Date du dernier envoi: le {{ membrePromoteur.last_send_mail | date }} à {{ membrePromoteur.last_send_mail | dtFormat('HH[H]mm') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, orderBy } from 'lodash'
import { mapGetters, mapState } from 'vuex'
import { bus, EVENTS } from '@/bus'
import { Adv } from '@/mixins'
export default {
  name: 'ProcedureItem',
  components: {
    ContratItem: () => import('./ContratItem')
  },
  mixins: [Adv],
  props: {
    advPkProp: {
      type: String
    },
    source: {
      type: Object,
      default: () => {}
    },
    signatures: Array,
    resa: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      lreList: [],
      open: false,
      intervalId: null,
      canSendMailSeller: false
    }
  },
  computed: {
    ...mapState(['modal', 'device']),
    ...mapGetters(['isAdmin', 'isPromoteur']),
    /**
      * return yousign url
      * @returns {string}
      */
    yousignSignatureUrl () {
      return this.$configs.YOUSIGN_URL
    },
    /**
      * return source as procedure
      * @returns {object}
      */
    procedure () {
      return this.source
    },
    /**
      * is user empty
      * @returns {boolean}
      */
    isUserDelete () {
      return !isEmpty(this.user)
    },
    /**
      * buyer ordered
      * @returns {array}
      */
    membresBuyer () {
      let buyers = this.procedure.members.filter(x => {
        if (x.is_buyer || x.is_cobuyer) return x
      })
      let orderby = orderBy(buyers, x => {
        return x.position
      }, 'asc')
      return orderby
    },
    /**
      * return promoteur
      * @returns {object}
      */
    membrePromoteur () {
      return this.procedure.members.find(x => {
        return x.is_promoteur
      })
    },
    /**
      * everybody sign
      * @returns {boolean}
      */
    everybodySign () {
      let contratSign = []
      this.procedure.members.forEach(x => {
        if (x.status === 'signed') contratSign.push(x.status)
      })
      return contratSign.length === this.procedure.members.length
    },
    /**
      * can sign
      * @returns {boolean}
      */
    canSign () {
      let nbrPending = this.procedure.members.filter(x => {
        // V3 YOUSIGN ----------->
        return x.status === 'notified'
        // return x.status === 'pending'
      })
      nbrPending = nbrPending.length
      if (nbrPending === 1) return true
      else if (this.everybodySign) return true
      else return false
    },
    /**
      * procedure lre
      * @returns {array}
      */
    procedureLre () {
      return this.lreList.filter(x => {
        return !('construction_step_uuid' in x.details)
      })
    },
    member_last_send_mail () {
      if (this.membresBuyer[0].last_send_mail) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'CANCEL_SIGNATURE' && params.procedure === this.procedure.pk) {
          if (results.cancel) {
            this.cancel()
          } else {
            this.cancel(results)
          }
        } else if (mode === 'RECOMMENDED_MANAGEMENT') {
          if (params.requestElem.adv_pk === this.advPkProp && params.from === 'signature') {
            let idx = this.lreList.findIndex(x => {
              return x.details.buyer === results.details.buyer
            })
            if (idx >= 0 && !('construction_step_uuid' in results.details)) {
              this.lreList.splice(idx, 1, results)
            } else {
              this.lreList.push(results)
            }
          }
        }
      }
    },
    'member.last_send_mail' (newValue) {
      if (newValue) {
        clearInterval(this.intervalId)
      }
    },
    beforeDestroy () {
      clearInterval(this.intervalId)
    },
    canSign (newVal) {
      if (newVal) {
        this.sendYousignContractByMail(this.membrePromoteur, true)
      }
    }
    // everybodySign (newVal) {
    //   console.log('procdure newval =>', this.procedure)
    // }
  },
  created () {
    if (this.procedure.status === 'draft' || this.procedure.status === 'ongoing' || this.procedure.status === 'done') {
      this.open = true
      this.getContratLre()
    }
    bus.$on(EVENTS.RESERVATION_LRE_UPDATED, (data) => {
      for (let lre of this.lreList) {
        if (lre.lre_id === data.lre_id) {
          this.getContratLre()
        }
      }
    })
  },
  methods: {
    /**
      * add lre
      * @param {object} lre
      */
    addLre (lre) {
      this.lreList.push(lre)
    },
    /**
      * get contrat lre
      */
    async getContratLre () {
      try {
        let { data } = await this.$api.axios.get('lre', {
          params: {
            reservation: this.advPkProp
          }
        })
        this.lreList = data.items
      } catch (err) {

      }
    },
    /**
      * open preview contrat
      */
    openPreviewContrat () {
      let params = {
        link: this.currentAdv.signed_contract
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    /**
      * open preview contrat by membre
      */
    openPreviewContratMembre () {
      const apiUrl = this.$configs.APIURL
      let params = {
        link: apiUrl + '/yousign-file/' + this.membrePromoteur.file_id
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    /**
      * open preview
      */
    openPreview (elem) {
      // V3 YOUSIGN ------------>
      const procedure = elem.signature_link
      let sandboxLink = procedure + (procedure.includes('?') ? '&' : '?') + 'disable_domain_validation=true'
      let params = {
        link: sandboxLink
      }
      // V3 YOUSIGN END ------------>
      // let params = {
      //   link: this.yousignSignatureUrl + '/procedure/sign?members=/members/' + elem.yousign_id
      // }
      if (this.device === 'desktop') {
        this.$store.commit('setModal', { mode: 'YOUSIGN_PREVIEW', params })
      } else {
        let link = document.createElement('a')
        link.href = params.link
        link.target = '_blank'
        link.click()
      }
    },
    /**
      * confirm cancel
      */
    confirmCancel () {
      let params = {
        procedure: this.procedure.pk
      }
      this.$store.commit('setModal', { mode: 'CANCEL_SIGNATURE', params })
    },
    /**
      * cancel
      * @param {object} result
      */
    async cancel (result = null) {
      let params = {}
      if (result) {
        this.$set(this.procedure, 'deleted_reason', result)
        params.deleted_reason = this.procedure.deleted_reason
      }
      let { data } = await this.$api.delete(this.$resources.PROCEDURE, this.procedure.pk, params)
      this.$emit('updateProcedure', data)
      this.$toasted.global.success('Procédure annulé')
    },
    /**
      * toggle procedure
      */
    toggleProcedure () {
      this.open = !this.open
    },
    startChecking () {
      let attempts = 0
      this.intervalId = setInterval(async () => {
        await this.checkLastSendMail()
        attempts++
        if (attempts >= 3) {
          clearInterval(this.intervalId)
        }
      }, 5000)
    },
    async checkLastSendMail () {
      try {
        const response = await this.$api.axios.get(`/get-signing-procedure-member/${this.membrePromoteur.yousign_id}`)
        this.membrePromoteur.last_send_mail = response.data.last_send_mail
      } catch (err) {
        console.error("Erreur lors de la récupération de la date d'envoi du mail", err)
      }
    }
  }
}
</script>
<style>
.same-width {
  min-width: 200px; /* Ajuste cette valeur selon tes besoins */
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>
